export const GET_COMPANY_DATA = 'GET_COMPANY_DATA';
export const LOGIN_COMPANY_SUPER_ADMIN = 'LOGIN_COMPANY_SUPER_ADMIN';
export const UPDATE_COMPANY_LOGO = 'UPDATE_COMPANY_LOGO';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const ADD_SOCIAL_MEDIA = 'ADD_SOCIAL_MEDIA';
export const SET_SOCIAL_MEDIA = 'SET_SOCIAL_MEDIA';
export const SET_IS_LOADING = 'SET_IS_LOADING';
